import React from "react";
import "./TodoCard.css";

const TodoCard = ({ todo }) => {
  return (
    <div className="todo-card">
      <div className="todo-card-header">
        <span className="todo-title">{todo.title}</span>
        <span className={`todo-status ${todo.isCompleted ? "complete" : "incomplete"}`}>
          {todo.isCompleted ? "Complete" : "Incomplete"}
        </span>
      </div>

      <div className="todo-card-body">
        <p className="todo-desc">{todo.description}</p>
        <p className="todo-date">
          Date: {new Date(todo.createdAt).toISOString().split("T")[0]}
        </p>
      </div>
    </div>
  );
};

export default TodoCard;
